import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorImportModel, ModalResponse } from '../../../models/shared-component/modal-response-model';

@Component({
  selector: 'app-error-import-modal',
  templateUrl: './error-import-modal.component.html',
  styleUrls: ['./error-import-modal.component.scss']
})
export class ErrorImportModalComponent implements OnInit {

  @Input() message: Array<ErrorImportModel>;

  isChecked = false;

  constructor(public bsModalRef: NgbActiveModal) { }

  ngOnInit(): void {
  }

  cancel(): void {
    this.bsModalRef.close();
  }

}
